import { IApiRequestConfig } from '../api.types';

export const getSubscriptionAccessApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getSubscriptionAccess',
  action: 'subscription/access',
  method: 'get',
  v2: true,
});

export const getSubscriptionApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getSubscription',
  action: 'subscription',
  method: 'get',
  v2: true,
});

export const startBillingApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'startBilling',
  action: 'subscription/billing',
  method: 'post',
  v2: true,
});

export const deleteSubscriptionApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteSubscription',
  action: 'subscription',
  method: 'delete',
  v2: true,
});

export const getBillingInfoApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getBillingInfo',
  action: 'billing-info',
  method: 'get',
  v2: true,
});

export const saveBillingInfoApi = (data: {
  address: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
}): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'saveBillingInfo',
  action: 'billing-info',
  method: 'put',
  data,
  v2: true,
});

export const reactivateSubscriptionApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'reactivateSubscription',
  action: 'subscription/reactivate',
  method: 'post',
  v2: true,
});
